export const GET_USER_DATA = 'GET_USER_DATA';
export const SET_LOADER_SCREEN = 'SET_LOADER_SCREEN';
export const GET_USER_CONFIG = 'GET_USER_CONFIG';
export const GET_SELECTED_MARKET = 'GET_SELECTED_MARKET';
